import { View } from "binder"
import { ActivityTypeManipulationViewModel, ActivityType } from "./activityTypeManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ActivityTypeManipulationView extends View<ActivityTypeManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-C39199BE-CD2E-42D2-A533-0C26E4E60CD1"
    }
    loadHtml(): string {
        let element = require('./activityTypeManipulation.html').default;
        let style = require('./activityTypeManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set activityTypes(v: ActivityType) { this._activityTypes = v; } public get activityTypes(): ActivityType { return this._activityTypes; } private _activityTypes: ActivityType;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
